<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="xblock layui-form shop-nav-one">
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" v-model="warehouse" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option v-for="item in warehouseList" :value="item.id" v-text="item.name"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" class="layui-input" v-on:keydown.13="GetList(true)" v-model="id" placeholder="用户ID搜索"
              autocomplete="off" />
          </div>
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" style="height: 36px;" lay-filter="sreach" v-on:click="GetList(true)"><i
                class="fa fa-search"></i></button>
          </div>
          <span class="x-right xblock-row" v-text="'共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table">
          <thead>
            <tr>
              <th>仓库</th>
              <th>用户ID</th>
              <th>类型</th>
              <th>所属商家</th>
              <th>店铺名称</th>
              <th>站点</th>
              <th>使用状态</th>
              <th>授权时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index" :class="{'expired':item.expired}">
              <td>
                <div style="width: 45px;">
                  <i v-if="item.warehouse == val.id" v-for="val in warehouseList" v-text="val.name"></i>
                </div>
              </td>
              <td v-text="item.uid"></td>
              <td>
                <i v-if="item.main_account_id">全球店铺</i>
                <i v-else>普通店铺</i>
              </td>
              <td>
                <i v-if="item.merchant_name" v-text="item.merchant_name"></i>
                <i v-else>-</i>
              </td>
              <td v-text="item.name"></td>
              <td v-text="item.country"></td>
              <td>
                <div style="width: 55px;">
                  <i class="status-box status-box-green">已授权</i>
                </div>
              </td>
              <td v-text="item.auth_time"></td>
              <td class="btn-arr">
                <button class="layui-btn" v-on:click="UpdateShop">更新授权</button>
                <button class="layui-btn layui-btn-warm" v-on:click="ConfirmHint(2,item)">解除授权</button>
                <button class="layui-btn layui-btn-danger" v-on:click="ConfirmHint(1,item)">删除店铺</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box">
        <div id="pagebox" class="pagebox"></div>
      </div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

      <!-- 确认框 -->
      <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        isLoding: true,
        ishow: "none",
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        id: null,
        item: null,
        page: 1,
        count: 0,
        total: 0,
        list: [],
        warehouse: 0,
        warehouseList: null,
        page_num: 20
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("货代", self.$route.name);
      let mid = self.$route.query.main_account_id
      let id = self.$route.query.shop_id
      let code = self.$route.query.code
      self.warehouseList = warehouseList;
      console.log(self.warehouse)

      if (localStorage.getItem("ExShopee_Sort") == "货代") {
        $(".shop-nav-one").show();
        $(".shop-nav-two").hide();
      } else {
        $(".shop-nav-one").hide();
        $(".shop-nav-two").show();
      }

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //授权类型
        form.on('radio(ShopType)', function(data) {
          if ($('#ShopType input[name="shop"]:checked').val() == "2") {
            $(".login-img").show();
            $('.layui-layer').height('635px');
            $('.layui-layer-content').css({
              height: '535px'
            });
          } else {
            $(".login-img").hide();
            $('.layui-layer').height('250px');
            $('.layui-layer-content').css({
              height: '150px'
            });
          }
          form.render();
        });

        form.on('select(status_selection)', function(data) {
          self.warehouse = data.value;
          self.GetList(true)
        });

        form.render();
        self.GetList();
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetList(state) {
        if (state) {
          self.list = [];
          self.page = 1;
        }
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        param.append('page', self.page)
        if (self.id) {
          param.append('uid', self.id)
        }
        if (self.warehouse && self.warehouse > 0) {
          param.append('warehouse', self.warehouse)
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/shop_list/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            if (datas.page) {
              for (let i in datas.list) {
                datas.list[i].auth_time = self.timestampToTime(datas.list[i].auth_time)
              }
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            console.log(json.msg);
          }

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_authorization() {
        var newwin = window.open();
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_authorization/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            newwin.location.href = datas;
            layer.closeAll();
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      synchronize_orders(id) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('shop_id', id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/synchronize_orders/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.ishow = "none";

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.Confirm.style = 1;
            self.Confirm.state = true;
            self.Confirm.txt = "订单导入成功，是否前往订单列表？"
          }, false, true);

        }).catch(function(error) {
          self.ishow = "none";
          self.loading = false;
          console.log(error);
        })
      },
      AddShop(title) {
        layer.open({
          type: 1,
          offset: '100px',
          title: "选择授权店铺类型",
          area: ['800px', '250px'],
          fixed: false, //不固定
          btn: ['店铺授权'],
          // btn: ['店铺授权', '查看我的店铺类型'],
          content: StoreAuthorization,
          success: function() {
            form.render();
          },
          yes: function(index, layero) {
            self.get_authorization();
          },
          btn2: function(index, layero) {
            window.open("https://exshopee.cn/privacy");
          }
        });
      },
      UpdateShop() {
        self.get_authorization();
      },
      ConfirmHint(te, item) {
        self.Confirm.style = 2;
        self.Confirm.state = true;
        if (te == 1) {
          self.Confirm.txt = "是否确认删除？"
        } else {
          self.Confirm.txt = "是否确认解除授权？"
        }
        self.item = item;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (self.Confirm.style == 1) {
          if (data.state) {
            console.log(data.state)
            self.Confirm.state = false;
            self.isLogin = true;
            localStorage.setItem("ExShopee_HistoryURL", "Order");
            self.GoToPage('/Order?te=0'); // 路由跳转
          }
        } else {
          if (data.state) {
            self.Confirm.state = false;
            let param = new URLSearchParams()
            param.append('id', self.item.id)
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/del_shop/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.GetList();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .xblock-row {
    margin: 5px 0;
    margin-right: 5px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .shop-nav-two {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/logistics/Shop.vue